import { TreeviewItem } from '../../../shared/components/tree-view';

export const JobDepartmentCategoryData = [
  new TreeviewItem({
    text: 'Finance', checked: false, value: 1, collapsed: true, children: [
      { text: 'Accounting & Reporting', value: 1, checked: false },
      { text: 'Accounts Payable (AP)', value: 1, checked: false },
      { text: 'Accounts Receivable (AR)', value: 1, checked: false },
      { text: 'Audit & Control', value: 1, checked: false },
      { text: 'Budgeting', value: 1, checked: false },
      { text: 'Collections', value: 1, checked: false },
      { text: 'Contract & Document Management', value: 1, checked: false },
      { text: 'Financial Consolidation Systems', value: 2, checked: false },
      { text: 'Financial Operations', value: 1, checked: false },
      { text: 'Financial Planning & Analysis (FP&A)', value: 1, checked: false },
      { text: 'Fixed Asset Systems', value: 1, checked: false },
      { text: 'Investor Relations (IR)', value: 1, checked: false },
      { text: 'Mergers & Acquisitions (M&A)', value: 1, checked: false },
      { text: 'Payments', value: 1, checked: false },
      { text: 'Payroll, Benefits & Compensation', value: 2, checked: false },
      { text: 'Project Management', value: 9, checked: false },
      { text: 'Tax Provisioning & Compliance', value: 1, checked: false },
      { text: 'Vendor Management', value: 9, checked: false },
    ]
  }),
  new TreeviewItem({
    text: 'HR', checked: false, value: 1, collapsed: true, children: [
      { text: 'Career Planning and Development', value: 1, checked: false },
      { text: 'Diversity & Inclusion', value: 1, checked: false },
      { text: 'Employee Relations', value: 1, checked: false },
      { text: 'HR Operations', value: 1, checked: false },
      { text: 'HRIS', value: 2, checked: false },
      { text: 'Learning Management & eLearning', value: 1, checked: false },
      { text: 'Orientation & Onboarding', value: 1, checked: false },
      { text: 'Payroll, Benefits & Compensation', value: 2, checked: false },
      { text: 'Performance Management', value: 1, checked: false },
      { text: 'Project Management', value: 9, checked: false },
      { text: 'Staffing', value: 1, checked: false },
      { text: 'Vendor Management', value: 9, checked: false },
    ]
  }),
  new TreeviewItem({
    text: 'IT', value: 1, checked: false, collapsed: true, children: [
      { text: 'Analytics & Business Intelligence (BI)', value: 2, checked: false },
      { text: 'Communications & Mobility', value: 1, checked: false },
      { text: 'Contact Center & Customer Service', value: 3, checked: false },
      { text: 'CRM', value: 2, checked: false },
      { text: 'Customer Service, Sales & Marketing', value: 3, checked: false },
      { text: 'Databases & Data Storage', value: 1, checked: false },
      { text: 'DevOps', value: 2, checked: false },
      { text: 'Digital Transformation & Emerging Technology', value: 2, checked: false },
      { text: 'eCommerce', value: 2, checked: false },
      { text: 'Engineering Software & Systems', value: 2, checked: false },
      { text: 'Enterprise Software & Applications', value: 1, checked: false },
      { text: 'Financial Consolidation Systems', value: 2, checked: false },
      { text: 'Hardware', value: 1, checked: false },
      { text: 'Help Desk', value: 1, checked: false },
      { text: 'HRIS', value: 2, checked: false },
      { text: 'Industry Specific Technology', value: 1, checked: false },
      { text: 'Information Security', value: 1, checked: false },
      { text: 'Infrastructure, Cloud Hosting & Virtualization', value: 1, checked: false },
      { text: 'Inventory Tracking', value: 2, checked: false },
      { text: 'IT Asset Management (ITAM)', value: 1, checked: false },
      { text: 'IT Compliance & IT Audit', value: 1, checked: false },
      { text: 'IT Enterprise Architecture', value: 1, checked: false },
      { text: 'IT Operations', value: 1, checked: false },
      { text: 'IT Service Management (ITSM)', value: 1, checked: false },
      { text: 'IT Strategy', value: 1, checked: false },
      { text: 'IT Training', value: 1, checked: false },
      { text: 'Machine Learning & Artificial Intelligence (ML/AI)', value: 2, checked: false },
      { text: 'Mobile Design', value: 2, checked: false },
      { text: 'Multimedia & Video', value: 2, checked: false },
      { text: 'Network Management', value: 1, checked: false },
      { text: 'Open Source', value: 1, checked: false },
      { text: 'Product Development & Lifecycle Management', value: 2, checked: false },
      { text: 'Program Management', value: 2, checked: false },
      { text: 'Project Management', value: 9, checked: false },
      { text: 'Quality Assurance', value: 2, checked: false },
      { text: 'SEO & Demand Generation', value: 2, checked: false },
      { text: 'Software & Applications Development', value: 1, checked: false },
      { text: 'Supply Chain & Logistics', value: 2, checked: false },
      { text: 'Testing & Performance', value: 2, checked: false },
      { text: 'Vendor Management', value: 9, checked: false },
      { text: 'Web Development & User Experience (UI/UX)', value: 1, checked: false },
      { text: 'Website Design', value: 2, checked: false },
    ]
  }),
  new TreeviewItem({
    text: 'Legal', checked: false, value: 1, collapsed: true, children: [
      { text: 'Audit', value: 1, checked: false },
      { text: 'Case Management', value: 1, checked: false },
      { text: 'Dispute Resolution', value: 1, checked: false },
      { text: 'Governance, Risk & Compliance (GRC)', value: 1, checked: false },
      { text: 'Government Relations & Regulatory', value: 1, checked: false },
      { text: 'Intellectual Property', value: 1, checked: false },
      { text: 'Legal Operations', value: 1, checked: false },
      { text: 'Legal Practice', value: 1, checked: false },
      { text: 'Legal Research & eDiscovery', value: 1, checked: false },
      { text: 'Privacy Law', value: 1, checked: false },
      { text: 'Project Management', value: 9, checked: false },
      { text: 'Vendor Management', value: 9, checked: false },
    ]
}),
  new TreeviewItem({
    text: 'Marketing', checked: false, value: 1, collapsed: true, children: [
      { text: 'Account Based Marketing (ABM)', value: 1, checked: false },
      { text: 'Analytics & Business Intelligence (BI)', value: 2, checked: false },
      { text: 'Brand & Product Management', value: 1, checked: false },
      { text: 'Creative/Content', value: 1, checked: false },
      { text: 'Customer Service, Sales & Marketing', value: 3, checked: false },
      { text: 'Digital Advertising', value: 1, checked: false },
      { text: 'eCommerce', value: 2, checked: false },
      { text: 'Field & Direct Marketing', value: 1, checked: false },
      { text: 'Imaging/Graphics', value: 1, checked: false },
      { text: 'Lead Generation & Management', value: 2, checked: false },
      { text: 'Marketing Communications (Marcom)', value: 1, checked: false },
      { text: 'Marketing Operations (Marops)', value: 1, checked: false },
      { text: 'Mobile Design', value: 2, checked: false },
      { text: 'Multimedia & Video', value: 2, checked: false },
      { text: 'Project Management', value: 9, checked: false },
      { text: 'Revenue Operations (RevOps)', value: 2, checked: false },
      { text: 'SEO & Demand Generation', value: 2, checked: false },
      { text: 'Social', value: 1, checked: false },
      { text: 'Strategic Communications, Public Relations (PR) & Media Relations', value: 1, checked: false },
      { text: 'Technical Marketing', value: 1, checked: false },
      { text: 'Vendor Management', value: 9, checked: false },
      { text: 'Webinars & Events', value: 1, checked: false },
      { text: 'Website Design', value: 2, checked: false },
    ]
}),
  new TreeviewItem({
    text: 'Operations', checked: false, value: 1, collapsed: true, children: [
      { text: 'Clinical Systems, Health & Medical', value: 1, checked: false },
      { text: 'Compliance', value: 1, checked: false },
      { text: 'Construction Management', value: 1, checked: false },
      { text: 'Contact Center & Customer Service', value: 3, checked: false },
      { text: 'Corporate Strategy', value: 1, checked: false },
      { text: 'Environmental Health & Safety (EHS)', value: 1, checked: false },
      { text: 'Facilities Management', value: 1, checked: false },
      { text: 'Freight Carrier', value: 1, checked: false },
      { text: 'Freight Forwarder', value: 1, checked: false },
      { text: 'HVAC, Electric, Heating & Cooling', value: 1, checked: false },
      { text: 'Inventory Tracking', value: 2, checked: false },
      { text: 'Medical & Health Operations', value: 1, checked: false },
      { text: 'Occupational Health and Safety', value: 1, checked: false },
      { text: 'Office Management', value: 1, checked: false },
      { text: 'Physical Security', value: 1, checked: false },
      { text: 'Project Management', value: 9, checked: false },
      { text: 'Real Estate & Leasing', value: 1, checked: false },
      { text: 'Retail & Store Operations', value: 1, checked: false },
      { text: 'Shipping & Receiving', value: 1, checked: false },
      { text: 'Supply Chain & Logistics', value: 2, checked: false },
      { text: 'Transportation', value: 1, checked: false },
      { text: 'Vendor Management', value: 9, checked: false },
      { text: 'Waste Management', value: 1, checked: false },
    ]
}),
  new TreeviewItem({
    text: 'Procurement', checked: false, value: 1, collapsed: true, children: [
      { text: 'Business Process Management', value: 1, checked: false },
      { text: 'Offshore Outsourcing', value: 1, checked: false },
      { text: 'Onshore Outsourcing', value: 1, checked: false },
      { text: 'Project Management', value: 9, checked: false },
      { text: 'Strategic Sourcing', value: 1, checked: false },
      { text: 'Vendor Management', value: 9, checked: false },
    ]
}),
  new TreeviewItem({
    text: 'R&D', checked: false, value: 1, collapsed: true, children: [
      { text: 'Applied Research', value: 1, checked: false },
      { text: 'Chemical, Pharmaceutical & Biotechnology Engineering', value: 1, checked: false },
      { text: 'DevOps', value: 2, checked: false },
      { text: 'Digital Transformation & Emerging Technology', value: 2, checked: false },
      { text: 'Engineering Software & Systems', value: 2, checked: false },
      { text: 'Industrial Engineering & Production', value: 1, checked: false },
      { text: 'Laboratory Devices', value: 1, checked: false },
      { text: 'Machine Learning & Artificial Intelligence (ML/AI)', value: 2, checked: false },
      { text: 'Materials Management', value: 1, checked: false },
      { text: 'Medical Devices', value: 1, checked: false },
      { text: 'Product Development & Lifecycle Management', value: 2, checked: false },
      { text: 'Program Management', value: 2, checked: false },
      { text: 'Project Management', value: 9, checked: false },
      { text: 'Quality Assurance', value: 2, checked: false },
      { text: 'Quantitative/Qualitative Research', value: 1, checked: false },
      { text: 'Technology Operations', value: 1, checked: false },
      { text: 'Testing & Performance', value: 2, checked: false },
      { text: 'Vendor Management', value: 9, checked: false },
    ]
}),
  new TreeviewItem({
    text: 'Sales', checked: false, value: 1, collapsed: true, children: [
      { text: 'Account Management', value: 1, checked: false },
      { text: 'Contact Center & Customer Service', value: 3, checked: false },
      { text: 'CRM', value: 2, checked: false },
      { text: 'Customer Experience Management (CX)', value: 1, checked: false, },
      { text: 'Customer Service, Sales & Marketing', value: 3, checked: false, },
      { text: 'Field Sales', value: 1, checked: false },
      { text: 'Forecasting and Planning', value: 1, checked: false },
      { text: 'Inside Sales & Business Development', value: 1, checked: false },
      { text: 'Lead Generation & Management', value: 2, checked: false },
      { text: 'Partnerships & Channel Sales', value: 1, checked: false },
      { text: 'Project Management', value: 9, checked: false },
      { text: 'Revenue Operations (RevOps)', value: 2, checked: false },
      { text: 'Sales Enablement', value: 1, checked: false },
      { text: 'Sales Engineering', value: 1, checked: false },
      { text: 'Sales Operations (Salesops)', value: 1, checked: false },
      { text: 'Sales Training', value: 1, checked: false },
      { text: 'Vendor Management', value: 9, checked: false },
    ]
}),
  new TreeviewItem({
    text: 'Cross Functional', checked: false, value: 1, collapsed: true, children: []
})];
